// src/components/departments/DepartmentList.js
import React from 'react';
import { Link } from 'react-router-dom';

function DepartmentList({ departments }) {
  if (!departments || departments.length === 0) {
    return (
      <div className="empty-list">
        <p>No departments found. Create your first department to get started.</p>
      </div>
    );
  }

  return (
    <div className="department-list">
      {departments.map((department) => (
        <Link 
          key={department.id} 
          to={`/admin/departments/${department.id}`}
          className="department-list-item"
        >
          <span className="department-name">{department.name}</span>
          <span className="department-arrow">→</span>
        </Link>
      ))}
    </div>
  );
}

export default DepartmentList;